import Link from "next/link";
import type { Crumb } from "@/lib/construction/schema";
import { cn } from "@/lib/cn";

type BreadcrumbsProps = {
  crumbs: Crumb[];
  tone?: "light" | "dark";
};

/** Visible breadcrumb trail. The matching BreadcrumbList is in the page's JSON-LD graph. */
export function Breadcrumbs({ crumbs, tone = "light" }: BreadcrumbsProps) {
  return (
    <nav aria-label="Breadcrumb" className={cn("text-xs", tone === "dark" ? "text-white/60" : "text-ink-muted")}>
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1">
        {crumbs.map((crumb, i) => {
          const last = i === crumbs.length - 1;
          return (
            <li key={crumb.href} className="flex items-center gap-2">
              {last ? (
                <span aria-current="page" className={cn("max-w-[60vw] truncate", tone === "dark" ? "text-white" : "text-ink")}>
                  {crumb.cms ? <span data-mdlfy-cms={crumb.cms}>{crumb.name}</span> : crumb.name}
                </span>
              ) : (
                <Link
                  href={crumb.href}
                  className={cn(
                    "underline-offset-4 transition-colors hover:underline focus-visible:outline-none focus-visible:ring-2",
                    tone === "dark" ? "hover:text-white focus-visible:ring-white" : "hover:text-ink focus-visible:ring-ink",
                  )}
                >
                  {crumb.cms ? <span data-mdlfy-cms={crumb.cms}>{crumb.name}</span> : crumb.name}
                </Link>
              )}
              {!last ? (
                <span aria-hidden="true" className={tone === "dark" ? "text-white/30" : "text-ink/30"}>
                  /
                </span>
              ) : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
